import { getCounterTemplate, getVueCounter } from "../../shortcodes/templates";

let counter = null;
const visualizeCounter = content => {
  counter = content.querySelectorAll('[data-wrapper-id="counter"]');
  if (counter.length > 0) {
    counter.forEach(item => {
      const data = item.querySelector("counter")?.getAttribute("quantity");

      if (data) {
        item.innerHTML = getCounterTemplate(decodeURIComponent(data));
      }
    });
  }
};

const serializeCounter = content => {
  const counter = content.querySelectorAll('[data-wrapper-id="counter"]');
  if (counter.length > 0) {
    counter.forEach(item => {
      if (!item.querySelector("counter")) {
        const data = item.querySelector(".counter")?.innerHTML?.replace(/{|}/g, "");
        if (data) {
          item.innerHTML = getVueCounter(encodeURIComponent(data));
        }
      }
    });
  }
};

export { visualizeCounter, serializeCounter };
